import React from "react"

type CollectionMenuItem = {
  title: string
  handle: string
}

export type Props = {
  collectionMenuItems: CollectionMenuItem[]
}

export function CollectionMenu({ collectionMenuItems }: Props) {
  if (!collectionMenuItems?.length) return null

  return (
    <>
      {collectionMenuItems.map((collection, index) =>
        collection?.title ? (
          <a
            key={index}
            href={`/collections/${collection.handle}`}
            className="collection-banner--menu-link"
          >
            {collection.title}
            <span className="collection-banner--menu-link-underline"></span>
          </a>
        ) : null
      )}
    </>
  )
}
